import { ResultadoPagamento } from '../types/checkout';

export interface WebhookPayload {
  email: string;
  nome: string;
  empresa: string;
  cnpj: string;
  plano: string;
  paymentId?: string;
  subscriptionId?: string;
  timestamp: string;
}

class WebhookService {
  private baseURL: string;

  constructor() {
    // Usar URL de produção em produção, local em desenvolvimento
    this.baseURL = process.env.NODE_ENV === 'production' 
      //? 'https://cipa.ehsfacil.com'
      ? 'https://cipa-homolog.ehsfacil.com'
      : (process.env.REACT_APP_ASAAS_WEBHOOK_URL_HML || 'https://cipa-homolog.ehsfacil.com');
  }

  // Enviar dados do pagamento para webhook
  async enviarDadosPagamento(resultado: ResultadoPagamento): Promise<boolean> {
    try {
      if (!resultado.webhookData) {
        console.warn('⚠️ [WEBHOOK] Nenhum dado de webhook disponível');
        return false;
      }

      const payload: WebhookPayload = {
        email: resultado.webhookData.email,
        nome: resultado.webhookData.nome,
        empresa: resultado.webhookData.empresa,
        cnpj: resultado.webhookData.cnpj,
        plano: resultado.webhookData.plano,
        paymentId: resultado.paymentId,
        subscriptionId: resultado.subscriptionId,
        timestamp: new Date().toISOString()
      };

      const response = await fetch(`${this.baseURL}/api/webhook`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`Erro HTTP: ${response.status}`);
      }

      const result = await response.json();
      
      return true;
    } catch (error) {
      console.error('❌ [WEBHOOK] Erro ao enviar dados:', error);
      return false;
    }
  }

  // Gerar dados para função SQL
  gerarSQL(resultado: ResultadoPagamento): string {
    if (!resultado.webhookData) {
      return '-- Nenhum dado de webhook disponível';
    }

    const { email, nome, empresa, cnpj, plano } = resultado.webhookData;
    
    return `SELECT criar_usuario_kiwify(
  '${email}',
  '${nome}',
  '${empresa}',
  '${cnpj}',
  '${plano}'
);`;
  }

  // Validar dados do webhook
  validarDados(resultado: ResultadoPagamento): { valido: boolean; erros: string[] } {
    const erros: string[] = [];

    if (!resultado.webhookData) {
      erros.push('Dados do webhook não disponíveis');
      return { valido: false, erros };
    }

    const { email, nome, cnpj, plano } = resultado.webhookData;

    if (!email || !email.includes('@')) {
      erros.push('Email inválido');
    }

    if (!nome || nome.trim().length < 2) {
      erros.push('Nome inválido');
    }

    if (!cnpj || cnpj.length < 11) {
      erros.push('CNPJ/CPF inválido');
    }

    if (!plano || plano.trim().length < 2) {
      erros.push('Plano inválido');
    }

    return {
      valido: erros.length === 0,
      erros
    };
  }
}

const webhookService = new WebhookService();
export default webhookService;
